import { DOCUMENT, CommonModule } from '@angular/common';
import { EventEmitter, Directive, ChangeDetectorRef, Output, Component, ChangeDetectionStrategy, Inject, ViewChildren, ElementRef, InjectionToken, NgModule, ComponentFactoryResolver, Injector } from '@angular/core';
import { AwButtonComponent, AwButtonModule } from '@aw/ads-components/aw-button';
import { FocusQueueService } from '@aw/ads-components/src/services/focus-queue';
import { getUniqueID } from '@aw/ads-components/src/utils';
import * as Noty from 'noty';
import { setMaxVisible, closeAll } from 'noty';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@aw/ads-components/src/services/focus-queue';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@aw/ads-components/aw-button';

function BannerComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 7);
    ɵngcc0.ɵɵtext(2, "error_outline");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c0 = function (a0) { return { "m-r0": a0 }; };
function BannerComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "aw-button", 9, 10);
    ɵngcc0.ɵɵlistener("onClick", function BannerComponent_div_6_Template_aw_button_onClick_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onAction.emit(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r5 = ctx.ngIf;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, !ctx_r1.data.closeBtnAriaLabel));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("elementId", ctx_r1.actionBtnId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", action_r5, " ");
} }
function BannerComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "aw-button", 12);
    ɵngcc0.ɵɵlistener("onClick", function BannerComponent_div_7_Template_aw_button_onClick_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.close(); });
    ɵngcc0.ɵɵelementStart(2, "i", 13);
    ɵngcc0.ɵɵtext(3, "close");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ariaLabel_r9 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("aw-aria-label", ariaLabel_r9);
} }
function BannerComponent_ng_template_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 7);
    ɵngcc0.ɵɵtext(2, "warning_amber");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function BannerComponent_ng_template_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 7);
    ɵngcc0.ɵɵtext(2, "error_outline");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function BannerComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 14);
    ɵngcc0.ɵɵtemplate(1, BannerComponent_ng_template_8_ng_container_1_Template, 3, 0, "ng-container", 15);
    ɵngcc0.ɵɵtemplate(2, BannerComponent_ng_template_8_ng_container_2_Template, 3, 0, "ng-container", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r4.data.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "warning");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "danger");
} }
const _c1 = function (a0) { return [a0]; };
class Notification {
    constructor(_cdr) {
        this._cdr = _cdr;
        this.onShow = new EventEmitter();
        this.onClose = new EventEmitter();
        this.onShow.subscribe(() => this.ngOnInit());
    }
    set context(context) {
        this._context = context;
        this._buildNoty();
        this.refresh();
    }
    get context() {
        return this._context;
    }
    ngOnInit() {
        this._noty.show();
    }
    ngOnDestroy() {
        this.onShow.complete();
        this.onClose.complete();
    }
    show() {
        this.onShow.emit();
    }
    close() {
        this.onClose.emit();
        this._noty.close();
    }
    refresh() {
        if (this.isDestroyed) {
            return;
        }
        this._cdr.detectChanges();
    }
    get isDestroyed() {
        return this._context.componentRef.hostView.destroyed;
    }
    get getNotyOptions() {
        return this._noty;
    }
    _buildNoty() {
        const { layoutDomClasses, componentRef } = this._context;
        const context = this._context;
        this._noty = new Noty(Object.assign({ callbacks: {
                onTemplate() {
                    const instance = this;
                    if (layoutDomClasses) {
                        instance.layoutDom.classList.add(...layoutDomClasses);
                    }
                    const node = componentRef.hostView.rootNodes[0];
                    instance.barDom.innerHTML = '';
                    instance.barDom.appendChild(node);
                    const encapsulationID = ([].slice.apply(node.attributes)
                        .map((attr) => attr.name)
                        .find((attr) => attr.includes('nghost')) || '')
                        .replace('host', 'content');
                    instance.layoutDom.setAttribute(encapsulationID, '');
                    instance.barDom.setAttribute(encapsulationID, '');
                },
                onClose() {
                    context.componentRef.destroy();
                }
            } }, this.context.options));
    }
    get data() {
        return this.context.data;
    }
}
Notification.ɵfac = function Notification_Factory(t) { return new (t || Notification)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
Notification.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: Notification, outputs: { onShow: "onShow", onClose: "onClose" } });
Notification.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
Notification.propDecorators = {
    onShow: [{ type: Output }],
    onClose: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Notification, [{
        type: Directive
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { onShow: [{
            type: Output
        }], onClose: [{
            type: Output
        }] }); })();

class NotificationService {
    constructor(cfr, injector, options) {
        this.cfr = cfr;
        this.injector = injector;
        this._id = getUniqueID();
        this._options = options;
        setMaxVisible(options.maxVisible, this._id);
    }
    build(context) {
        const componentFactory = this.cfr.resolveComponentFactory(this._options.component);
        const componentRef = componentFactory.create(this.injector);
        componentRef.instance.context = this._buildFullContext(context, componentRef);
        return componentRef.instance;
    }
    closeShown() {
        closeAll(this._id);
    }
    _buildFullContext(context, componentRef) {
        const { notyOptions, layoutDomClasses } = this._options;
        return Object.assign(Object.assign({}, context), { options: Object.assign(Object.assign(Object.assign({}, notyOptions), context.options), { queue: this._id }), layoutDomClasses: [...layoutDomClasses], componentRef });
    }
}

class BannerComponent extends Notification {
    constructor(cdr, focusQueueService, document) {
        super(cdr);
        this.cdr = cdr;
        this.focusQueueService = focusQueueService;
        this.document = document;
        this.contentId = getUniqueID();
        this.actionBtnId = getUniqueID();
        this.onAction = new EventEmitter();
    }
    ngOnInit() {
        super.ngOnInit();
        this.focusQueueService.save();
        this._setFocusOnFirstButton();
        this.setAttrsForNotyLayoutEl();
        this.setAttrsForNotyBar();
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.focusQueueService.restore();
        this.onAction.complete();
    }
    _setFocusOnFirstButton() {
        const firstButtonEl = this.buttonsList.first;
        if (firstButtonEl) {
            const firstButton = firstButtonEl.nativeElement.querySelector('button');
            if (firstButton) {
                firstButton.focus();
            }
        }
    }
    setAttrsForNotyLayoutEl() {
        const notyLayoutEl = this.document.querySelector('#noty_layout__topCenter');
        if (notyLayoutEl) {
            notyLayoutEl.removeAttribute('role');
            notyLayoutEl.removeAttribute('aria-live');
        }
    }
    setAttrsForNotyBar() {
        const notyBarEl = this.document.querySelector(`#${this.getNotyOptions.id}`);
        if (notyBarEl) {
            notyBarEl.setAttribute('role', 'alert');
            notyBarEl.setAttribute('aria-labelledby', this.contentId);
        }
    }
}
BannerComponent.ɵfac = function BannerComponent_Factory(t) { return new (t || BannerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FocusQueueService), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
BannerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BannerComponent, selectors: [["aw-banner"]], viewQuery: function BannerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(AwButtonComponent, true, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttonsList = _t);
    } }, outputs: { onAction: "onAction" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 10, vars: 9, consts: [[1, "aw-banner", 3, "ngClass"], [1, "aw-banner--flex"], [1, "aw-banner__text"], [4, "ngIf", "ngIfElse"], ["class", "aw-banner__action", 3, "ngClass", 4, "ngIf"], ["class", "btn-close", 4, "ngIf"], ["errorIcons", ""], [1, "material-icons-outlined"], [1, "aw-banner__action", 3, "ngClass"], ["styleClasses", "btn-flat btn-small btn-primary btn-action", 3, "elementId", "onClick"], ["actionBtn", ""], [1, "btn-close"], ["styleClasses", "icon-link", 3, "aw-aria-label", "onClick"], ["aria-hidden", "true", 1, "material-icons-outlined"], [3, "ngSwitch"], [4, "ngSwitchCase"]], template: function BannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, BannerComponent_ng_container_3_Template, 3, 0, "ng-container", 3);
        ɵngcc0.ɵɵelementStart(4, "p");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, BannerComponent_div_6_Template, 4, 5, "div", 4);
        ɵngcc0.ɵɵtemplate(7, BannerComponent_div_7_Template, 4, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, BannerComponent_ng_template_8_Template, 3, 3, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = ɵngcc0.ɵɵreference(9);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c1, ctx.data.style ? ctx.data.style : ""));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.showIcon)("ngIfElse", _r3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("id", ctx.contentId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.contentText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.actionText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.closeBtnAriaLabel);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc3.AwButtonComponent, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase], styles: ["#noty_layout__topCenter[_ngcontent-%COMP%]{-ms-transform:translate(-50%) translateZ(0) scale(1);left:50%;top:.5rem;transform:translate(calc(-50% - .5px)) translateZ(0) scale(1);width:368px}.noty_bar[_ngcontent-%COMP%]     .noty_close_button{display:none}#noty_layout__topCenter[_ngcontent-%COMP%], .noty_layout_mixin[_ngcontent-%COMP%]{-webkit-filter:blur(0);-webkit-font-smoothing:subpixel-antialiased;backface-visibility:hidden;filter:blur(0);margin:0;max-width:90%;padding:0;position:fixed;transform:translateZ(0) scale(1);z-index:10}.banner-wrap[_ngcontent-%COMP%]{overflow:hidden}.banner-wrap[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{bottom:auto;max-height:250px;top:0;transition:all .7s ease}.banner-wrap[_ngcontent-%COMP%] > div.banner_top_anim_in[_ngcontent-%COMP%], .banner-wrap[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3):not(.banner_top_anim_out){animation:banner_top_anim_in .5s ease}.banner-wrap[_ngcontent-%COMP%] > div.banner_top_anim_in[_ngcontent-%COMP%]{overflow:hidden}.banner-wrap[_ngcontent-%COMP%] > div.banner_top_anim_in[_ngcontent-%COMP%] + .noty_bar[_ngcontent-%COMP%]:not(.banner_top_anim_out){animation:banner_top_anim_in .5s ease}.banner-wrap[_ngcontent-%COMP%] > div.banner_top_anim_out[_ngcontent-%COMP%]{animation:banner_top_anim_out .5s ease;max-height:0;overflow:hidden}.banner-wrap[_ngcontent-%COMP%]:not(.noty-container){-ms-transform:none!important;bottom:auto;left:0!important;max-width:100%!important;top:0!important;transform:none!important;width:100%!important;z-index:9999!important}.aw-banner[_ngcontent-%COMP%]{background:#fff;padding:1.1rem 1.5rem;position:relative}@media only screen and (max-width:991px){.aw-banner[_ngcontent-%COMP%]{padding:1.1rem 1rem}}.aw-banner[_ngcontent-%COMP%]:after{background:#bec3cc;background:var(--aw-banner-after-bg,#bec3cc);bottom:0;content:\"\";display:block;height:1px;left:0;position:absolute;width:100%}.aw-banner--flex[_ngcontent-%COMP%]{-ms-flex-align:center;-ms-flex-pack:center;-ms-flex-wrap:wrap;align-items:center;display:-ms-flexbox;display:flex;flex-wrap:wrap;justify-content:center;position:relative}@media only screen and (max-width:991px){.aw-banner--flex[_ngcontent-%COMP%]{-ms-flex-align:center;-ms-flex-pack:justify;-ms-flex-wrap:nowrap;align-items:center;flex-wrap:nowrap;justify-content:space-between}}.aw-banner--flex[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]{bottom:0;bottom:var(--aw-banner-btn-close-p-b,0);max-width:48px;position:absolute;right:0}@media screen and (min-width:0\\0){.aw-banner--flex[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]{bottom:-8px!important}}@media only screen and (max-width:991px){.aw-banner--flex[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]{position:relative}}.aw-banner--flex[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]     .icon-link{color:#232a30;color:var(--aw-banner-icon-link-color,#232a30);display:block}.aw-banner__text[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;padding-right:1rem}@media only screen and (max-width:991px){.aw-banner__text[_ngcontent-%COMP%]{-ms-flex-align:center;align-items:center}}.aw-banner__text[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#1a1f24;color:var(--aw-banner-text-color,#1a1f24);line-height:1.5rem;margin-bottom:0!important}.aw-banner__text[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .aw-banner__text[_ngcontent-%COMP%]   .material-icons-outlined[_ngcontent-%COMP%]{color:#1a1f24;color:var(--aw-banner-text-color,#1a1f24);margin-right:1rem}.aw-banner__action[_ngcontent-%COMP%]{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;margin-right:3rem}@media only screen and (max-width:991px){.aw-banner__action[_ngcontent-%COMP%]{margin-left:auto;margin-right:1rem}}.aw-banner.warning[_ngcontent-%COMP%]{color:#fff;color:var(--white,#fff)}.aw-banner.warning[_ngcontent-%COMP%]:after{background:#a75203;background:var(--aw-banner-warning-hover,#a75203);height:1px}.aw-banner.danger[_ngcontent-%COMP%], .aw-banner.warning[_ngcontent-%COMP%]   .aw-banner__action[_ngcontent-%COMP%]     .btn-flat, .aw-banner.warning[_ngcontent-%COMP%]   .aw-banner__action[_ngcontent-%COMP%]     .btn-flat:hover, .aw-banner.warning[_ngcontent-%COMP%]   .aw-banner__text[_ngcontent-%COMP%]   .material-icons-outlined[_ngcontent-%COMP%], .aw-banner.warning[_ngcontent-%COMP%]   .aw-banner__text[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .aw-banner.warning[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]     .icon-link, .aw-banner.warning[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]     .icon-link:hover{color:#fff;color:var(--white,#fff)}.aw-banner.danger[_ngcontent-%COMP%]:after{background:#c33537;background:var(--aw-banner-danger-hover,#c33537);height:1px}.aw-banner.danger[_ngcontent-%COMP%]   .aw-banner__action[_ngcontent-%COMP%]     .btn-flat, .aw-banner.danger[_ngcontent-%COMP%]   .aw-banner__action[_ngcontent-%COMP%]     .btn-flat:hover, .aw-banner.danger[_ngcontent-%COMP%]   .aw-banner__text[_ngcontent-%COMP%]   .material-icons-outlined[_ngcontent-%COMP%], .aw-banner.danger[_ngcontent-%COMP%]   .aw-banner__text[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .aw-banner.danger[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]     .icon-link, .aw-banner.danger[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]     .icon-link:hover, .aw-banner.success[_ngcontent-%COMP%]{color:#fff;color:var(--white,#fff)}.aw-banner.success[_ngcontent-%COMP%]:after{background:#007b05;background:var(--aw-banner-success-hover,#007b05);height:1px}.aw-banner.success[_ngcontent-%COMP%]   .aw-banner__action[_ngcontent-%COMP%]     .btn-flat, .aw-banner.success[_ngcontent-%COMP%]   .aw-banner__action[_ngcontent-%COMP%]     .btn-flat:hover, .aw-banner.success[_ngcontent-%COMP%]   .aw-banner__text[_ngcontent-%COMP%]   .material-icons-outlined[_ngcontent-%COMP%], .aw-banner.success[_ngcontent-%COMP%]   .aw-banner__text[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .aw-banner.success[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]     .icon-link, .aw-banner.success[_ngcontent-%COMP%]   .btn-close[_ngcontent-%COMP%]     .icon-link:hover{color:#fff;color:var(--white,#fff)}@keyframes banner_top_anim_in{0%{transform:translate3d(0,-100%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes banner_top_anim_out{0%{opacity:.5}to{opacity:0}}"], changeDetection: 0 });
BannerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: FocusQueueService },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
BannerComponent.propDecorators = {
    onAction: [{ type: Output }],
    buttonsList: [{ type: ViewChildren, args: [AwButtonComponent, { read: ElementRef },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BannerComponent, [{
        type: Component,
        args: [{
                selector: 'aw-banner',
                template: "<div \n    class=\"aw-banner\"\n    [ngClass]=\"[data.style ? data.style : '']\"\n    >\n    <div class=\"aw-banner--flex\">\n        <div class=\"aw-banner__text\">\n            <ng-container *ngIf=\"data.showIcon; else errorIcons\">\n                <span class=\"material-icons-outlined\">error_outline</span>\n            </ng-container>\n            <p [attr.id]=\"contentId\">{{ data.contentText }}</p>\n        </div>\n        <div class=\"aw-banner__action\" *ngIf=\"data.actionText as action\"\n            [ngClass]=\"{ 'm-r0': !data.closeBtnAriaLabel }\">\n            <aw-button\n                [elementId]=\"actionBtnId\"\n                (onClick)=\"onAction.emit()\"\n                styleClasses=\"btn-flat btn-small btn-primary btn-action\"\n                #actionBtn\n            >\n                {{ action }}\n            </aw-button>\n        </div>\n        <div class=\"btn-close\" *ngIf=\"data.closeBtnAriaLabel as ariaLabel\">\n            <aw-button (onClick)=\"close()\" styleClasses=\"icon-link\" [aw-aria-label]=\"ariaLabel\">\n                <i class=\"material-icons-outlined\" aria-hidden=\"true\">close</i>\n            </aw-button>\n        </div>\n    </div>\n</div>\n<ng-template #errorIcons>\n    <ng-container [ngSwitch]=\"data.style\">\n        <ng-container *ngSwitchCase=\"'warning'\"><span class=\"material-icons-outlined\">warning_amber</span></ng-container>\n        <ng-container *ngSwitchCase=\"'danger'\"><span class=\"material-icons-outlined\">error_outline</span></ng-container>\n    </ng-container>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["#noty_layout__topCenter{-ms-transform:translate(-50%) translateZ(0) scale(1);left:50%;top:.5rem;transform:translate(calc(-50% - .5px)) translateZ(0) scale(1);width:368px}.noty_bar ::ng-deep .noty_close_button{display:none}#noty_layout__topCenter,.noty_layout_mixin{-webkit-filter:blur(0);-webkit-font-smoothing:subpixel-antialiased;backface-visibility:hidden;filter:blur(0);margin:0;max-width:90%;padding:0;position:fixed;transform:translateZ(0) scale(1);z-index:10}.banner-wrap{overflow:hidden}.banner-wrap>div{bottom:auto;max-height:250px;top:0;transition:all .7s ease}.banner-wrap>div.banner_top_anim_in,.banner-wrap>div:nth-child(3):not(.banner_top_anim_out){animation:banner_top_anim_in .5s ease}.banner-wrap>div.banner_top_anim_in{overflow:hidden}.banner-wrap>div.banner_top_anim_in+.noty_bar:not(.banner_top_anim_out){animation:banner_top_anim_in .5s ease}.banner-wrap>div.banner_top_anim_out{animation:banner_top_anim_out .5s ease;max-height:0;overflow:hidden}.banner-wrap:not(.noty-container){-ms-transform:none!important;bottom:auto;left:0!important;max-width:100%!important;top:0!important;transform:none!important;width:100%!important;z-index:9999!important}.aw-banner{background:#fff;padding:1.1rem 1.5rem;position:relative}@media only screen and (max-width:991px){.aw-banner{padding:1.1rem 1rem}}.aw-banner:after{background:#bec3cc;background:var(--aw-banner-after-bg,#bec3cc);bottom:0;content:\"\";display:block;height:1px;left:0;position:absolute;width:100%}.aw-banner--flex{-ms-flex-align:center;-ms-flex-pack:center;-ms-flex-wrap:wrap;align-items:center;display:-ms-flexbox;display:flex;flex-wrap:wrap;justify-content:center;position:relative}@media only screen and (max-width:991px){.aw-banner--flex{-ms-flex-align:center;-ms-flex-pack:justify;-ms-flex-wrap:nowrap;align-items:center;flex-wrap:nowrap;justify-content:space-between}}.aw-banner--flex .btn-close{bottom:0;bottom:var(--aw-banner-btn-close-p-b,0);max-width:48px;position:absolute;right:0}@media screen and (min-width:0\\0){.aw-banner--flex .btn-close{bottom:-8px!important}}@media only screen and (max-width:991px){.aw-banner--flex .btn-close{position:relative}}.aw-banner--flex .btn-close ::ng-deep .icon-link{color:#232a30;color:var(--aw-banner-icon-link-color,#232a30);display:block}.aw-banner__text{display:-ms-flexbox;display:flex;padding-right:1rem}@media only screen and (max-width:991px){.aw-banner__text{-ms-flex-align:center;align-items:center}}.aw-banner__text p{color:#1a1f24;color:var(--aw-banner-text-color,#1a1f24);line-height:1.5rem;margin-bottom:0!important}.aw-banner__text .icon,.aw-banner__text .material-icons-outlined{color:#1a1f24;color:var(--aw-banner-text-color,#1a1f24);margin-right:1rem}.aw-banner__action{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;margin-right:3rem}@media only screen and (max-width:991px){.aw-banner__action{margin-left:auto;margin-right:1rem}}.aw-banner.warning{color:#fff;color:var(--white,#fff)}.aw-banner.warning:after{background:#a75203;background:var(--aw-banner-warning-hover,#a75203);height:1px}.aw-banner.danger,.aw-banner.warning .aw-banner__action ::ng-deep .btn-flat,.aw-banner.warning .aw-banner__action ::ng-deep .btn-flat:hover,.aw-banner.warning .aw-banner__text .material-icons-outlined,.aw-banner.warning .aw-banner__text p,.aw-banner.warning .btn-close ::ng-deep .icon-link,.aw-banner.warning .btn-close ::ng-deep .icon-link:hover{color:#fff;color:var(--white,#fff)}.aw-banner.danger:after{background:#c33537;background:var(--aw-banner-danger-hover,#c33537);height:1px}.aw-banner.danger .aw-banner__action ::ng-deep .btn-flat,.aw-banner.danger .aw-banner__action ::ng-deep .btn-flat:hover,.aw-banner.danger .aw-banner__text .material-icons-outlined,.aw-banner.danger .aw-banner__text p,.aw-banner.danger .btn-close ::ng-deep .icon-link,.aw-banner.danger .btn-close ::ng-deep .icon-link:hover,.aw-banner.success{color:#fff;color:var(--white,#fff)}.aw-banner.success:after{background:#007b05;background:var(--aw-banner-success-hover,#007b05);height:1px}.aw-banner.success .aw-banner__action ::ng-deep .btn-flat,.aw-banner.success .aw-banner__action ::ng-deep .btn-flat:hover,.aw-banner.success .aw-banner__text .material-icons-outlined,.aw-banner.success .aw-banner__text p,.aw-banner.success .btn-close ::ng-deep .icon-link,.aw-banner.success .btn-close ::ng-deep .icon-link:hover{color:#fff;color:var(--white,#fff)}@keyframes banner_top_anim_in{0%{transform:translate3d(0,-100%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes banner_top_anim_out{0%{opacity:.5}to{opacity:0}}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.FocusQueueService }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { onAction: [{
            type: Output
        }], buttonsList: [{
            type: ViewChildren,
            args: [AwButtonComponent, { read: ElementRef }]
        }] }); })();

const TopBannerToken = new InjectionToken('TopBannerNotificationService');
const topBannerNotificationServiceFactory = (cfr, injector) => {
    const options = {
        component: BannerComponent,
        maxVisible: 3,
        notyOptions: {
            timeout: 0,
            layout: 'topCenter',
            closeWith: ['button'],
            animation: {
                open: 'banner_top_anim_in',
                close: 'banner_top_anim_out'
            },
            force: true
        },
        layoutDomClasses: ['banner-wrap']
    };
    return new NotificationService(cfr, injector, options);
};

const COMPONENTS = [BannerComponent];
const ɵ0 = topBannerNotificationServiceFactory;
class NotificationsModule {
}
NotificationsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NotificationsModule });
NotificationsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NotificationsModule_Factory(t) { return new (t || NotificationsModule)(); }, providers: [
        {
            provide: TopBannerToken,
            useFactory: ɵ0,
            deps: [
                ComponentFactoryResolver,
                Injector
            ]
        }
    ], imports: [[CommonModule, AwButtonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NotificationsModule, { declarations: function () { return [BannerComponent]; }, imports: function () { return [CommonModule, AwButtonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, AwButtonModule],
                providers: [
                    {
                        provide: TopBannerToken,
                        useFactory: ɵ0,
                        deps: [
                            ComponentFactoryResolver,
                            Injector
                        ]
                    }
                ],
                declarations: COMPONENTS,
                entryComponents: COMPONENTS
            }]
    }], null, null); })();

export { BannerComponent, Notification, NotificationService, NotificationsModule, TopBannerToken, topBannerNotificationServiceFactory, ɵ0 };

//# sourceMappingURL=aw-ads-components-notifications.js.map